module.exports = __webpack_public_path__ + "static/media/study 210707.34fca351.png";